import { render, staticRenderFns } from "./Kairos.vue?vue&type=template&id=3d37189b&scoped=true"
import script from "./Kairos.vue?vue&type=script&lang=js"
export * from "./Kairos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d37189b",
  null
  
)

export default component.exports